import { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import AppLoader from './pages/AppLoader';
import BanquetCelesteRouter from './pages/private/banquetceleste/Router';
import BasseCourRouter from './pages/private/bassecour/Router';
import CaeterraRouter from './pages/private/caeterra/Router';
import ChienNoirRouter from './pages/private/chiennoir/Router';
import CollectifNodeRouter from './pages/private/collectifnode/Router';
import DejaDemainRouter from './pages/private/dejademain/Router';
import GensDeMerRouter from './pages/private/gensdemer/Router';
import JeuneDargentreRouter from './pages/private/jeunedargentre/Router';
import KerbouzierRouter from './pages/private/kerbouzier/Router';
import MaisonMousseRouter from './pages/private/maisonmousse/Router';
import MelismesRouter from './pages/private/melismes/Router';
import NouvelleParentheseRouter from './pages/private/nouvelleparenthese/Router';
import PRNARouter from './pages/private/prna/Router';
import SolarysRouter from './pages/private/solarys/Router';
import SuperAdminRouter from './pages/private/superadmin/Router';
import WhisperRouter from './pages/private/whisper/Router';
import SignIn from './pages/public/Signin/SignIn';

import useScreenSize from './hooks/useScreenSize';
import MobileCatcher from './pages/MobileCatcher';

import { useAccountContext } from './contexts/AccountContext';
import PasswordSetup from './pages/public/PasswordSetUp/PasswordSetUp';
import RecoverPassword from './pages/public/RecoverPassword/RecoverPassword';

function Router() {
  const { isLoggedIn, accountContext } = useAccountContext();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const screenSize = useScreenSize();

  useEffect(() => {
    if (!isLoggedIn && !pathname.startsWith('/password-setup')) {
      navigate('/');
    }
  }, [accountContext]);

  useEffect(() => {
    if (screenSize.width < 700) {
      navigate('/mobile-catcher');
    }
  }, []);

  const getScopeRouter = () => {
    if (!isLoggedIn || !accountContext.scope) return null;
    switch (accountContext.scope.slug) {
      case 'caeterra':
        return <CaeterraRouter />;
      case 'nouvelleparenthese':
        return <NouvelleParentheseRouter />;
      case 'banquetceleste':
        return <BanquetCelesteRouter />;
      case 'jeunedargentre':
        return <JeuneDargentreRouter />;
      case 'maisonmousse':
        return <MaisonMousseRouter />;
      case 'dejademain':
        return <DejaDemainRouter />;
      case 'collectifnode':
        return <CollectifNodeRouter />;
      case 'whisper':
        return <WhisperRouter />;
      case 'kerbouzier':
        return <KerbouzierRouter />;
      case 'bassecour':
        return <BasseCourRouter />;
      case 'gensdemer':
        return <GensDeMerRouter />;
      case 'superadmin':
        return <SuperAdminRouter />;
      case 'solarys':
        return <SolarysRouter />;
      case 'chiennoir':
        return <ChienNoirRouter />;
      case 'melismes':
        return <MelismesRouter />;
      case 'prna':
        return <PRNARouter />;
      default:
        console.log(`Error : Unknown Scope slug : ${accountContext.scope.slug}`);
        break;
    }
  };
  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route exact path="/login" element={<SignIn />} />
        <Route path="/" element={<AppLoader />} />
        <Route path="/recover-password" element={<RecoverPassword />} />
        <Route exact path="/password-setup/:token" element={<PasswordSetup />} />
        <Route exact path="/mobile-catcher" element={<MobileCatcher />} />
      </Routes>
      {/* Private routes */}
      {getScopeRouter()}
    </>
  );
}

export default Router;
